export const errors = {
  notFound: {
    title: '404',
    heading: 'Not Found',
    description: "The page you're looking for doesn't exist.",
    goBack: 'Go Back',
    goHome: 'Go Home',
  },
  forbidden: {
    title: '403',
    heading: 'Forbidden',
    description: "You don't have permission to access this resource.",
    goBack: 'Go Back',
    goHome: 'Go Home',
  },
} as const
